import MuiSkeleton, { type SkeletonProps } from "@mui/material/Skeleton";

type Props = Pick<
  SkeletonProps,
  "variant" | "width" | "height" | "sx" | "animation" | "children" | "className"
>;

export const Skeleton = (props: Props) => <MuiSkeleton {...props} />;
